
import React from 'react'
import { Component } from 'react'

import Table from './Table'
import Selector from './Selector'
import ZitateList from './ZitateList'
import TableLoading from './loading/TableLoading'
import ZitatLoading from './loading/ZitatLoading'
import KeineErgebnisse from './KeineErgebnisse'

function SearchResults({ results, onPageChange, onShowZitat, hideSearch, loading, outputMode }) {
    let header = null;
    let widgets = null;

    let showTable = outputMode == "Tabelle" ? true
        : !outputMode && results.type === "table" ? true
            : false

    let showCitation = outputMode == "Zitate" ? true
        : !outputMode && results.type === "citations" ? true
            : false

    const _onRowClick = (pk) => {
        if (onShowZitat) {
            onShowZitat(pk);
        }
    };

    if (results) {
        if (!results.count && !loading && !hideSearch)
            header = <KeineErgebnisse />

        else /*if (results.count === 1)
            header = <div>1 Zitat</div>;
        else
            header = <div>{results.count} Zitate</div>;*/
            header = null;

        loading && !results.type ? widgets = (
            <div>
                <ZitatLoading />
                <ZitatLoading />
                <ZitatLoading />
            </div>
        ) : null

        if (showCitation && results.list)
            widgets = <ZitateList
                results={results}
                onShowZitat={onShowZitat}
                onPageChange={onPageChange}
                loadingPreview={loading ? (
                    <div>
                        <ZitatLoading />
                        <ZitatLoading />
                        <ZitatLoading />
                    </div>
                ) : null}
            />;

        else if (showTable)
            widgets = loading ?
                <TableLoading headers={results.table ? results.table.headers : [""]} /> :
                results.table && !loading ?
                    <Table headers={results.table.headers}
                        rows={results.table.rows}
                        columnTypes={results.table.column_types}
                        onRowClick={_onRowClick}
                    />
                    : null;
    }

    return (
        <div className={"result-box"}>
            {header}
            {widgets}
        </div>
    );
}

export default SearchResults;


// WEBPACK FOOTER //
// ./cms_plugins/expert_search/js/components/SearchResults.js